import React, { useEffect, useState } from 'react';
import useSearchParams from '../../../../hooks/useSearchParams';
import SearchField from '../../../../components/SearchField/SearchField';
import { callHistoryFilters } from '../../constants/callHistoryFilters';
import styles from './SearchItem.module.scss';

const SearchItem = ({ filterData, text, disabled = false }) => {
  const [filterVal, setFilterVal] = useSearchParams(filterData);
  const [searchValue, setSearchValue] = useState(filterVal);
  const [[fromDate, toDate]] = useSearchParams(callHistoryFilters.date);

  const handleChange = (e) => {
    setSearchValue(e.target.value);
  };

  useEffect(() => {
    let timer;

    if (fromDate && toDate) {
      timer = setTimeout(() => {
        setFilterVal(searchValue);
      }, 1000);
    }

    return () => clearTimeout(timer);
  }, [searchValue, fromDate, toDate]);

  return (
    <div className={styles.root}>
      <p className={styles.leftSide}>{text}</p>
      <SearchField
        value={searchValue}
        onChange={handleChange}
        className={styles.rightSide}
        disabled={disabled}
      />
    </div>
  );
};

export default SearchItem;
